import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoaderService {

  public loader = signal<{ loading: boolean; loadingMsg: string | null }>({
    loading: false,
    loadingMsg: null,
  });

  public show(msg: string | null = null) {
    this.loader.set({ loading: true, loadingMsg: msg });
  }

  public hide() {
    this.loader.set({ loading: false, loadingMsg: null });
  }
}
